var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-chat-bubble-file"},[_c('div',{staticClass:"v-chat-bubble-file__icon"},[_c('v-icon',{attrs:{"name":"attachment"}})],1),_c('div',{staticClass:"v-chat-bubble-file__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }